<kp-screen-email-signup-base headerTitle="Create a Password">
  <div icon class="header-icon">
    <svg-icon src="/assets/icons/lock.svg"></svg-icon>
  </div>
  <div instructions class="instructions">
    <kp-user-email emailKey="unconfirmedEmail" (email)="getUserEmail($event)"></kp-user-email>
  </div>
  <ng-container content>
    <form class="password-form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
      <div class="sub-container">
        <label>
          <span class="form-label password">Password</span>
          <div class="password-container">
            <input
              class="password-input"
              placeholder="Enter your password"
              required
              formControlName="password"
              name="password"
              id="password"
              (change)="passwordChanged()"
              (input)="passwordChanged()"
              [type]="showPassword ? 'text' : 'password'" />
            <button
              class="toggle-show-password"
              (click)="toggleShowPassword($event)"
              type="button"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
              <svg-icon
                [src]="
                  showPassword ? '/assets/icons/icons-nav-visibility.svg' : '/assets/icons/icons-nav-visibility-off.svg'
                "></svg-icon>
            </button>
          </div>
        </label>
        <div class="bottom-row">
          <div class="login-checkbox-container">
            <kp-checkbox [isChecked]="stayLoggedIn" (check)="loggedInCheckbox($event)">Stay Logged In</kp-checkbox>
          </div>
        </div>
        <p class="error" *ngIf="formatError">
          <svg-icon src="/assets/icons/alert-circle.svg"></svg-icon>
          <span>Password must be at least 8 characters and contain at least 1 number and 1 letter.</span>
        </p>
        <p class="error" *ngIf="submissionError">
          <svg-icon src="/assets/icons/alert-circle.svg"></svg-icon>
          <span>{{ submissionError }}</span>
        </p>
      </div>
      <button class="button button-pill button-submit" type="submit" [disabled]="!form?.valid">Continue</button>
      <a
        routerLink="/login/reset/code"
        class="reset-password button-text"
        *ngIf="showPasswordReset"
        (click)="setReturnUrl()">
        Reset password
      </a>
    </form>
  </ng-container>
</kp-screen-email-signup-base>
